import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircleOutlinedIcon } from "components";

const Features = [
  "Ticketing",
  "Project management",
  "Announcement",
  "Custom support mail address (up to 5)",
  "SLA and automated time tracking",
  "Contracts & invoicing",
  "SSO for user logins",
  "Service desk workflow builder",
  "Custom-branded web portal for customers",
  "DeskDay-branded Teams app for customers",
  "DeskDay-branded iOS & Android mobile app for customers",
  "DeskDay-branded iOS & Android mobile app for techs",
  "DeskDay-branded Windows & Mac desktop app for customers",
];

export const PlanDetailsCard = () => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        background: "linear-gradient(180deg, #F6F8FE 0%, #E3D4F9 100%)",
        borderRadius: "12px",
        border: "1px solid #E7E2F2",
        overflow: "scroll",
        "::-webkit-scrollbar": {
          display: "none",
        },
        // backgroundColor: theme.palette.secondary["purple-tint-3"],
      }}
    >
      <Stack p="32px" gap="24px">
        <Typography variant="h4" color={theme.palette.primary.main}>
          Simple pricing for your business
        </Typography>
        <Typography variant="h6">Access these features</Typography>
        <Stack gap="20px">
          {Features.map((feature) => (
            <Stack
              key={feature}
              gap="12px"
              direction="row"
              alignItems={"center"}
              ml="-8px"
            >
              <CheckCircleOutlinedIcon
                color="primary"
                fontSize="small"
                sx={{
                  width: "24px",
                  height: "24px",
                  aspectRatio: "1",
                }}
              />
              <Typography
                variant="body-medium"
                color={theme.palette.lightBg.medium}
              >
                {feature}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
